import { render, staticRenderFns } from "./recent.vue?vue&type=template&id=c1438986"
import script from "./recent.vue?vue&type=script&lang=ts"
export * from "./recent.vue?vue&type=script&lang=ts"
import style0 from "./recent.vue?vue&type=style&index=0&id=c1438986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports